import {
  NEXT_PUBLIC_ARKESTRO_ENV,
  NEXT_PUBLIC_INTERCOM_APP_ID,
  NEXT_PUBLIC_INTERCOM_EU_APP_ID,
  VALID_ENVIRONMENTS,
} from '@utils/constants';

// https://developers.intercom.com/installing-intercom/web/installation/#installing-the-messenger-for-regional-data-hosted-customers
const US_INTERCOM_APP_ID = NEXT_PUBLIC_INTERCOM_APP_ID;
const EU_INTERCOM_APP_ID = NEXT_PUBLIC_INTERCOM_EU_APP_ID;

export const collapsedIntercomLeft = 15;
export const expandedIntercomLeft = 30;
const verticalPadding = 90;

// https://developers.intercom.com/installing-intercom/web/installation/#standard-installation
class IntercomService {
  static initialize = () => {
    if (typeof window === 'undefined' || !VALID_ENVIRONMENTS.includes(NEXT_PUBLIC_ARKESTRO_ENV)) return;
    this.loadIntercomScript(US_INTERCOM_APP_ID);
    this.boot(US_INTERCOM_APP_ID);
  };

  static boot = (appId = US_INTERCOM_APP_ID) => {
    if (typeof window === 'undefined' || !window.Intercom || !VALID_ENVIRONMENTS.includes(NEXT_PUBLIC_ARKESTRO_ENV)) return;
    window.Intercom('boot', { app_id: appId });
  };

  static loadIntercomScript = appId => {

    /* eslint-disable func-names, prefer-rest-params */
    (function (){const w=window;
      const ic=w.Intercom;

      if (typeof ic==='function'){ic('reattach_activator');ic('update',w.intercomSettings);} else {const d=document;
        const i=function (){i.c(arguments);};

        i.q=[];i.c=function (args){i.q.push(args);};w.Intercom=i;const l=function (){const s=d.createElement('script');

          s.type='text/javascript';
          s.async=true;
          s.src=`https://widget.intercom.io/widget/${appId}`;
          const x=d.getElementsByTagName('script')[0];

          x.parentNode.insertBefore(s, x);};

        if (document.readyState==='complete'){
          l();
        } else if (w.attachEvent){
          w.attachEvent('onload',l);
        } else {
          w.addEventListener('load',l,false);
        }
      }
    })();
    /* eslint-enable func-names, prefer-rest-params */
  };

  static configureUser = (options = {}) => {
    if (!VALID_ENVIRONMENTS.includes(NEXT_PUBLIC_ARKESTRO_ENV)) return;
    if (typeof window === 'undefined' || !VALID_ENVIRONMENTS.includes(NEXT_PUBLIC_ARKESTRO_ENV) || !options.currentUser?.id) return;

    const user = options.currentUser.impersonating ? options.currentUser.true_user : options.currentUser;

    if (!user?.id) return;

    const appId = user.emea ? EU_INTERCOM_APP_ID : US_INTERCOM_APP_ID;

    const settings = this.userSettings(user, appId, options.collapsed);

    window.Intercom('update', settings);
    window.intercomUserSettings = settings;
  };

  // Load new User object into Intercom
  // This could be going from an anonymous user (logged out) to an identified (logged in) user.
  static userSettings = (user, appId, collapsed) => ({
    api_base: user.intercom_api_base,
    app_id: appId,
    company: user.company,
    created_at: user.created_at,
    email: user.email,
    horizontal_padding: collapsed ? collapsedIntercomLeft : expandedIntercomLeft,
    impersonated_user_email: user.impersonating ? user.email : null,
    is_demo_account: user.is_demo_account,
    is_self_serve: user.is_self_serve,
    is_superadmin_session: user.impersonating,
    job_title: user.job_title,
    name: user.name,
    plan_type: user.plan_type,
    role: user.role,
    subdomain: user.subdomain,
    subdomain_manager: user.is_company_owner,
    superadmin_user: user.true_user?.email,
    user_hash: user.intercom_hmac,
    user_id: user.id,
    userType: user.category,
    vertical_padding: verticalPadding,
  });

  static trackEvent = (eventName, metaData) => {
    if (typeof window === 'undefined' || !window.Intercom) return;
    window.Intercom('trackEvent', eventName, { ...window.intercomUserSettings, ...metaData });
  };
}

export default IntercomService;
